import { ChangeEvent } from 'react'
import { useFormikContext } from 'formik'

export default function useNumberValidations(): {
  allowFloatNumber: (e: ChangeEvent<HTMLInputElement>) => void
  allowInteger: (e: ChangeEvent<HTMLInputElement>) => void
} {
  const { setFieldValue } = useFormikContext()

  function allowFloatNumber(e: ChangeEvent<HTMLInputElement>): void {
    const { value } = e.target
    let formattedValue = ''

    if (value === '.') {
      formattedValue = value.replace(/[^0-9]/, '')
    } else {
      formattedValue = value.replace(/[^0-9|.|,]/, '')
    }
    setFieldValue(e.target.id, formattedValue)
  }

  function allowInteger(e: ChangeEvent<HTMLInputElement>): void {
    const { value } = e.target
    const formattedValue = value.replace(/[^0-9]/, '')
    setFieldValue(e.target.id, formattedValue)
  }

  return {
    allowFloatNumber,
    allowInteger
  }
}
